import React from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { Icon } from "components/SvgIcons";
import Button from "shared/Button/index";
import { colors } from "styles/colors";
import { isLibraryShowPurchasedRecipes, isLibraryShowSavedRecipes } from "../../store/libraryReducer";
import { useDispatch, useSelector } from "react-redux";
import { setPurchasedLibraryMode, setSavedLibraryMode } from "../../store/libraryReducer";
import { isUserLogin } from "store/loginReducer";
import { getOwner } from "store/userReducer/userSelectors";

import { MenuMain, Links, LinkItem, Title, LinkWrap, BtnBlock, ButtonsDesktop, MenuWraper } from "./styled";

const Menu = ({ type, toggleBurger, isSelebrity }) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const user = useSelector(getOwner);
  const isLogin = useSelector(isUserLogin);

  const _isLibraryShowPurchasedRecipes = useSelector(isLibraryShowPurchasedRecipes);
  const _isLibraryShowSavedRecipes = useSelector(isLibraryShowSavedRecipes);
  const isLibraryPageActive = router.pathname === "/library";

  const toSavedLibrary = () => {
    dispatch(setSavedLibraryMode());
  };

  const toPurchasedLibrary = () => {
    dispatch(setPurchasedLibraryMode());
  };

  const toAddRecipe = () => {
    toggleBurger();
    router.push("/add-recipe");
  };

  const toAddCollection = () => {
    toggleBurger();
    router.push("/add-collection");
  };

  return (
    <MenuWraper hideDesktop={!isLogin} isSelebrity={isSelebrity}>
      <MenuMain type={type}>
        <>
          <Links>
            <LinkItem onClick={toggleBurger} className={router.pathname === "/" ? "isActive" : ""}>
              <Link href="/" passHref>
                <LinkWrap>
                  <Icon icon="newhome" />
                  Home
                </LinkWrap>
              </Link>
            </LinkItem>
            <LinkItem onClick={toggleBurger} className={router.pathname === "/grocery-list" ? "isActive" : ""}>
              <Link href="/grocery-list" passHref>
                <LinkWrap>
                  <Icon icon="add-to-grocery" />
                  Grocery List
                </LinkWrap>
              </Link>
            </LinkItem>
          </Links>
          <Title>Your Library</Title>
          <Links>
            <LinkItem
              onClick={toggleBurger}
              className={_isLibraryShowSavedRecipes && isLibraryPageActive ? "isActive" : ""}
            >
              <Link href="/library" passHref>
                <LinkWrap onClick={toSavedLibrary}>
                  <Icon icon="saveslide" />
                  Liked
                </LinkWrap>
              </Link>
            </LinkItem>

            <LinkItem
              onClick={toggleBurger}
              className={_isLibraryShowPurchasedRecipes && isLibraryPageActive ? "isActive" : ""}
            >
              <Link href="/library" passHref>
                <LinkWrap onClick={toPurchasedLibrary}>
                  <Icon icon="newpurchase" />
                  Purchased
                </LinkWrap>
              </Link>
            </LinkItem>
          </Links>
          <>
            {user.is_creator && <Title>Creator Tools</Title>}
            <Links>
              {user.is_creator && (
                <LinkItem onClick={toggleBurger} className={router.pathname === "/dashboard" ? "isActive" : ""}>
                  <Link href="/dashboard" passHref>
                    <LinkWrap>
                      <Icon icon="dashboard_des" />
                      Dashboard
                    </LinkWrap>
                  </Link>
                </LinkItem>
              )}
              <LinkItem onClick={toggleBurger} className={router.pathname === "/recipe_manager" ? "isActive" : ""}>
                <Link href={`/recipe_manager`} passHref>
                  <LinkWrap>
                    <Icon icon="recipe_manager" />
                    Recipe Manager
                  </LinkWrap>
                </Link>
              </LinkItem>
            </Links>
          </>
        </>
        <BtnBlock>
          {user.is_creator === true && (
            <>
              <Button color={colors.RED} stylType="primary" text="Create Recipe" onClick={toAddRecipe} />
              <Button color={colors.RED} stylType="primary" text="Create Collection" onClick={toAddCollection} />
            </>
          )}
        </BtnBlock>
        <ButtonsDesktop />
      </MenuMain>
    </MenuWraper>
  );
};

export default Menu;
